<template>
    <!-- NOTE: BUG REQUIRES THIS PAGE w/Suspense wrapper: https://github.com/nuxt/nuxt/issues/21901 -->
    <NuxtLoadingIndicator color="repeating-linear-gradient(to right, rgb(var(--v-theme-secondary)) 0%, transparent 100%)" />
    <NuxtLayout>
        <Suspense>
            <NuxtPage />
        </Suspense>
    </NuxtLayout>
</template>

<script lang="ts" setup>
    const $config = useRuntimeConfig();
    const route = useRoute();
    const homeUrl = $config.public.environment.homeUrl;

    // Self-referencing canonical for every route. Set once here (not per page) so
    // there's no field to manage; derived from route.path, which excludes the query
    // string so filtered/utm/tracking variants collapse to a single canonical URL.
    // Trailing slash is dropped (except root) so /foo and /foo/ don't split.
    const canonicalUrl = computed<string>(() => {
        const path = route.path === '/' ? '/' : route.path.replace(/\/+$/, '');
        return `${homeUrl}${path}`;
    });

    useHead({
        link: [
            { rel: 'canonical', href: canonicalUrl }
        ]
    });
</script>
